"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const systems_1 = require("@/store/ducks/systems");
const systems_2 = require("@/services/systems");
const listSitesUseCase_1 = require("@/useCases/sites/listSitesUseCase");
function editSystemUseCase(systemId, payload) {
    return (dispatch) => {
        dispatch((0, systems_1.saveSystem)());
        return (0, systems_2.updateSystem)(systemId, payload)
            .then(async () => {
            dispatch((0, systems_1.saveSystemSuccess)());
            await (0, listSitesUseCase_1.listSites)()(dispatch);
            dispatch((0, systems_1.closeEditSystemModal)());
            dispatch((0, systems_1.openSystemToast)({
                status: "success",
                message: "System saved successfully",
            }));
        })
            .catch(() => {
            dispatch((0, systems_1.saveSystemError)());
            dispatch((0, systems_1.openSystemToast)({
                status: "error",
                message: "Error saving system",
            }));
        });
    };
}
exports.default = editSystemUseCase;
